import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import * as SearchAction from "store/search/action";
import Router from "router/router";
import * as css from "./css/child-panel";

function ChildPanel(props) {
  const {
    className,
    childList,
    onMouseEnter,
    onMouseLeave,
    searchAction,
  } = props;

  let history = useHistory();

  function toSearch({
    categoryId,
    optId,
    categoryName,
    categorySelf,
    categoryHasSelf,
    parentId,
    level,
    isSelect,
  }) {
    // 如果是自营类别，并且没有开启自营
    if (categorySelf && !categoryHasSelf) {
      searchAction.setKeyword(categoryName.trim());
      //   window.open(`${Router.basename}${Router.Search.path}`);
      history.push({ pathname: Router.Search.path });
    } else {
      let search = new URLSearchParams();
      if (categoryName) {
        search.append("parentCategoryId", parentId);
        search.append("categoryId", categoryId);
        search.append("categoryOptId", optId);
        search.append("categoryName", categoryName);
        search.append("categorySelf", categorySelf);
        search.append("level", level);
        search.append("isSelect", isSelect);
      }
      history.push({
        pathname: Router.Search.path,
        search: search.toString(),
      });
    }
  }
  return (
    <css.ChildPanel
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <css.Container>
        {childList.map((father, i) => {
          const {
            id,
            optId,
            parentId,
            name,
            childList: childListLevel2,
            isSelf,
            hasSelf,
            level,
            isSelect,
          } = father;

          return (
            <css.CategoryFloor key={i}>
              <css.FatherFloor>
                <span
                  className="name"
                  onClick={() => {
                    toSearch({
                      categoryId: id,
                      optId,
                      categoryName: name,
                      categorySelf: isSelf,
                      categoryHasSelf: hasSelf,
                      parentId,
                      level,
                      isSelect,
                    });
                  }}
                >
                  {name}
                </span>
                <img src={require("./img/more.png")} alt="" className="more" />
              </css.FatherFloor>
              {childListLevel2 && (
                <css.ChildrenFloor>
                  {childListLevel2.map((child, j) => {
                    const {
                      id,
                      optId,
                      parentId,
                      name,
                      isSelf,
                      hasSelf,
                      level,
                      isSelect,
                    } = child;

                    return (
                      <span
                        key={j}
                        className="name"
                        onClick={() => {
                          toSearch({
                            categoryId: id,
                            optId,
                            categoryName: name,
                            categorySelf: isSelf,
                            categoryHasSelf: hasSelf,
                            parentId,
                            level,
                            isSelect,
                          });
                        }}
                      >
                        {name}
                      </span>
                    );
                  })}
                </css.ChildrenFloor>
              )}
            </css.CategoryFloor>
          );
        })}
      </css.Container>
    </css.ChildPanel>
  );
}

export default connect(
  (state) => ({}),
  (f) => ({
    searchAction: {
      setKeyword() {
        f(SearchAction.setKeyword(...arguments));
      },
    },
  })
)(ChildPanel);
